module.exports = __webpack_public_path__ + "assets/img/240301.3480ba28.png";